import Button from "components/common/Button";
import Dropdown from "components/common/Dropdown";
import TextInput from "components/common/InputField/TextInput";
import ToggleInput from "components/common/InputField/ToggleInput";
import { getOtherDetails } from "constants/workforceDetails";
import { formatMoney } from "helpers";
import { useAppDispatch, useAppSelector } from "hooks/storeHooks";
import useGetAllAgent from "hooks/workforceHooks/useGetAllAgent";
import { debounce, truncate } from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { workforceActions } from "redux/Ldb/actions";

type FlowAllAgentProps = {
    filteredList: Record<string, any>[];
    setRefetch: (refetch: boolean) => void;
    refetch: boolean;
    setDebouncedSearch: (debouncedSearch: string) => void;
    setType: (type: string) => void;
    type: string;
    isActive: {
        id?: string;
        isActive?: boolean;
    };
    setIsActive: (isActive: { id?: string; isActive?: boolean }) => void;
};

const FlowAllAgent = ({
    filteredList,
    setRefetch,
    refetch,
    setDebouncedSearch,
    setType,
    type,
    isActive,
    setIsActive,
}: FlowAllAgentProps) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [search, setSearch] = useState<string>("");

    const { updateAgentStatusSuccess } = useAppSelector((state) => state?.workforce);

    const filterOptions = [
        {
            name: "Active",
            value: "active",
        },
        {
            name: "Order Processing",
            value: "orderProcessing",
        },
        {
            name: "Sales & Marketing",
            value: "marketingCampaign",
        },
        {
            name: "Inventory",
            value: "InventoryManagement",
        },
    ];

    const handleUpdateAgentStatus = (agentId: string, isActive: boolean) => {
        dispatch(workforceActions.updateAgentStatus(agentId, { isActive }));
    };

    useEffect(() => {
        if (Boolean(updateAgentStatusSuccess)) {
            dispatch(workforceActions.resetUpdateAgentStatusSuccess());
            setRefetch(!refetch);
        }
    }, [dispatch, updateAgentStatusSuccess]);

    return (
        <div className="">
            <div className=" mb-4 flex items-center gap-2">
                <TextInput
                    name={"search"}
                    type={"text"}
                    inputPlaceholder={"Search tasks"}
                    inputClassName={"!h-[38px] pl-[0px] !bg-white text-sm !mb-0"}
                    value={search}
                    onChange={(e) => setSearch(e?.target?.value)}
                    onInput={debounce((e: any) => {
                        setDebouncedSearch(e?.target?.value);
                    }, 800)}
                    containerClassname={"!w-full max-sm:!w-full"}
                    leftIcon={
                        <i className="ri-search-line before:content-['\f0d1] text-slate-400 mt-[2px]"></i>
                    }
                    inputContainerClassname={
                        "!rounded-[4px] max-sm:!w-full !pl-[25px] !h-[40px] !bg-white !border !border-slate-200"
                    }
                />

                <Dropdown
                    name="filter"
                    value={""}
                    dropdownTriggerClassName={" "}
                    handleChange={(name, value) => {
                        setType(value);
                    }}
                    dropdown={
                        <div className="bg-white flex items-center justify-between h-10 gap-2 py-2.5 !px-3 shadow-boxShadow-2 border border-slate-200 !rounded">
                            <span className="text-[13px] whitespace-nowrap font-rocGroteskMedium">
                                {type
                                    ? truncate(
                                          filterOptions?.find((item) => item?.value === type)?.name,
                                          {
                                              length: 12,
                                          }
                                      )
                                    : "All Agents"}
                            </span>

                            <div className="flex items-center space-x-2">
                                {type && (
                                    <i
                                        onClick={(e) => {
                                            e?.stopPropagation();
                                            setType("");
                                        }}
                                        className="ri-close-circle-fill text-sm text-slate-500"
                                    ></i>
                                )}
                                <i className="ri-arrow-down-s-line text-lg text-gm-50"></i>
                            </div>
                        </div>
                    }
                    dropdownClassName={"!w-full !mb-10 !-mt-7"}
                    dropdownContainerClasses={`shadow-cardShadow-4 !right-0 !mt-0  !w-[159px] max-sm:!w-full  rounded !max-h-fit !p-0 !top-[105%]`}
                    wholeContainerClass={`w-full`}
                    dropdownItemsClasses="!bg-transparent"
                    dropdownOptions={filterOptions?.map((item, idx) => {
                        return {
                            label: item?.name,
                            value: item?.value,
                        };
                    })}
                />
            </div>

            <div className="space-y-4">
                {filteredList?.map((agent, idx) => {
                    const otherDetails = getOtherDetails(agent?.type);
                    return (
                        otherDetails && (
                            <div
                                className="cursor-pointer max-w-[396px] shadow-[0px_4px_8px_-4px_rgba(16,24,40,0.12),0px_20px_24px_-4px_rgba(16,24,40,0.08)] rounded-xl bg-white"
                                key={idx}
                                onClick={() => {
                                    if (otherDetails?.canTurnOffAgent) {
                                        navigate(`/dashboard/forecast?agent=${agent?.type}`, {
                                            state: {
                                                internalNavigation: true,
                                            },
                                        });
                                    } else {
                                        if (agent?.activeAgent?.createdAt) {
                                            navigate(
                                                `/dashboard/workforce/ai-teammate/${agent?.activeAgent?._id}/${agent?._id}?currTab=1`,
                                                {
                                                    state: {
                                                        internalNavigation: true,
                                                    },
                                                }
                                            );
                                        } else {
                                            navigate(
                                                `/dashboard/workforce/ai-teammate/non-active/${agent?._id}`,
                                                {
                                                    state: {
                                                        internalNavigation: true,
                                                    },
                                                }
                                            );
                                        }
                                    }
                                }}
                            >
                                <div className="relative">
                                    {/* agent?.activeAgent?.createdAt */}
                                    {agent?.activeAgent?.isActive && (
                                        <p className="absolute top-5 right-4 !rounded !py-0.5 !px-2 !bg-[#F2FFF7] !text-[#16A34A] !w-fit">
                                            {" "}
                                            Active
                                        </p>
                                    )}
                                    <img
                                        src={otherDetails?.img}
                                        alt={otherDetails?.name}
                                        className="w-full max-h-[250px] object-cover rounded-t-xl"
                                        style={{
                                            backgroundColor: otherDetails?.color,
                                            height: "250px",
                                        }}
                                    />
                                </div>
                                <div className="bg-white rounded-b-xl py-4 px-5 text-sm min-h-[230px] flex flex-col justify-between">
                                    <div>
                                        <div className="flex items-center justify-between">
                                            <div className="flex items-center gap-2">
                                                <div
                                                    className="w-5 h-5 rounded-full flex items-center justify-center"
                                                    style={{
                                                        backgroundColor: otherDetails?.color,
                                                    }}
                                                >
                                                    <i className="ri-robot-fill text-white text-sm"></i>
                                                </div>
                                                <p className="text-base text-g-75">
                                                    {otherDetails?.name}
                                                </p>
                                            </div>
                                        </div>
                                        {(!agent?.activeAgent?.createdAt ||
                                            otherDetails?.canTurnOffAgent) && (
                                            <p className="text-slate-500">{otherDetails?.text}</p>
                                        )}
                                        {agent?.activeAgent?.createdAt &&
                                            !otherDetails?.canTurnOffAgent && (
                                                <div className="text-slate-500 ">
                                                    <div className="">
                                                        <p className="">
                                                            Created on:{" "}
                                                            {moment(
                                                                agent?.activeAgent?.createdAt
                                                            )?.format("MMM DD, YYYY")}
                                                        </p>
                                                        <p className="">
                                                            {agent?.onGoingTasks ?? 0} ongoing tasks
                                                        </p>
                                                    </div>
                                                    <div className="flex border border-slate-200 rounded-md mt-4">
                                                        <div className="py-2.5 px-4 flex-1 border-r border-r-slate-200">
                                                            <p className="">Total savings</p>
                                                            <p className="text-g-75">
                                                                $
                                                                {formatMoney().format(
                                                                    agent?.totalCostSaved
                                                                ) || 0}
                                                            </p>
                                                        </div>

                                                        <div className="py-2.5 px-4 flex-1">
                                                            <p className="">Time saved</p>
                                                            <p className="text-g-75">
                                                                {agent?.totalTimeSaved ?? 0}{" "}
                                                                {agent?.totalTimeSaved > 1
                                                                    ? "hours"
                                                                    : "hour"}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                    </div>
                                    <div
                                        className={`flex ${
                                            otherDetails?.status === "custom" ||
                                            otherDetails?.canTurnOffAgent
                                                ? "justify-start"
                                                : otherDetails?.icons?.length > 0
                                                ? "justify-between"
                                                : "justify-end"
                                        } mt-4`}
                                    >
                                        <div className="flex items-center gap-2 ">
                                            {otherDetails?.icons?.map((icon) => (
                                                <img
                                                    src={icon}
                                                    alt={icon}
                                                    width={32}
                                                    height={32}
                                                    className="w-6 h-6 p-1 border border-slate-200 rounded-full"
                                                />
                                            ))}
                                        </div>

                                        {agent?.activeAgent?.createdAt &&
                                        !otherDetails?.canTurnOffAgent ? (
                                            <Button
                                                btnClassname={`!rounded !py-1.5 !px-3 !text-white !w-fit `}
                                                style={{
                                                    backgroundColor:
                                                        otherDetails?.color ?? "#6562E5",
                                                }}
                                                btnText="View more info"
                                                onClick={() => {
                                                    navigate(
                                                        `/dashboard/workforce/ai-teammate/${agent?.activeAgent?._id}/${agent?._id}?currTab=1`,
                                                        {
                                                            state: {
                                                                internalNavigation: true,
                                                            },
                                                        }
                                                    );
                                                }}
                                            />
                                        ) : otherDetails?.canTurnOffAgent ? (
                                            <div
                                                className={`flex items-center gap-1 mt-4`}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                }}
                                            >
                                                <ToggleInput
                                                    checked={
                                                        isActive?.id === agent?._id
                                                            ? isActive?.isActive
                                                            : agent?.activeAgent?.isActive
                                                    }
                                                    name={"isActive"}
                                                    onChange={(e) => {
                                                        handleUpdateAgentStatus(
                                                            agent?._id,
                                                            e.target.checked
                                                        );
                                                        setIsActive({
                                                            id: agent?._id,
                                                            isActive: e.target.checked,
                                                        });
                                                    }}
                                                    className="before:!h-4 before:!w-4 h-5 w-[30px] before:left-[2px] rounded-[30px] s-slider"
                                                />{" "}
                                                <p className="text-slate-800 -mt-1 text-[13px] font-rocGroteskMedium">
                                                    Turn{" "}
                                                    {agent?.activeAgent?.isActive ? "off" : "on"}{" "}
                                                    agent
                                                </p>
                                            </div>
                                        ) : (
                                            otherDetails?.status !== "custom" && (
                                                <Button
                                                    btnClassname="!rounded !py-1.5 !px-3 !bg-n-20 !text-gm-50 !w-fit"
                                                    btnText="Setup"
                                                    onClick={() => {
                                                        navigate(
                                                            `/dashboard/workforce/ai-teammate/non-active/${agent?._id}`,
                                                            {
                                                                state: {
                                                                    internalNavigation: true,
                                                                },
                                                            }
                                                        );
                                                    }}
                                                />
                                            )
                                        )}
                                    </div>
                                </div>
                            </div>
                        )
                    );
                })}
            </div>
        </div>
    );
};

export default FlowAllAgent;
